import React, { useEffect, useState } from "react";
import { Card, Form, Breadcrumb, Pagination, Nav } from "react-bootstrap";
import { SuccessSwal, WarningSwal } from "../../helpers/alertseet";
import { useNavigate, useParams } from "react-router-dom";
import PopUpPayLoan from "../../components/popup/PopUpPayLoan";
import {
  get_loan_by_id,
  get_loan_historys,
  update_installment,
  update_loan,
} from "../../services/loan.service";
import { useStore } from "../../store";
import moment from "moment";
import converSex from "../../helpers/convertSex";
import convertPercent from "../../helpers/convertPercent";
import convertNumber from "../../helpers/convertNumber";
import convertStatusLoan from "../../helpers/convertStatusLoan";
import _ from "lodash";
import convertTypeLoan from "../../helpers/convertTypeLoan";
import PopUpShowImage from "../../components/popup/PopUpShowImage";
import { END_IMAGE } from "../../constants";
import PopUpDetailInstallment from "../../components/popup/PopUpDetailInstallment";
import cutBranchNo from "../../helpers/cutBranchNo";
import { update_activity_history } from "../../services/balance.service";
import PopUpConfirmDelete from "../../components/popup/PopUpConfirmDelete";
import PopUpUpdatePayLoan from "../../components/popup/PopUpUpdatePayLoan";
import ReactPaginate from "react-paginate";
import { Icon } from "@iconify/react";
import styled from "styled-components";
import PopUpUpdateLoan from "../../components/popup/PopUpUpdateLoan";
import { get_member } from "../../services/membership.service";
import PopUpConfirmDiscretion from "../../components/popup/PopUpConfirmDiscretion";

let limitData = 1;

export default function DetailLoanPage() {
  const navigate = useNavigate();
  const { loanId } = useParams();
  // state
  const [isLoading, setIsLoading] = useState(true);
  const [dropdown, setDropdown] = useState(false);
  const [popup, setPopup] = useState();
  const [loanData, setLoanData] = useState();
  const [selectLoanInstallment, setSelectLoanInstallment] = useState();
  const [amountInstallmentSuccess, setAmountInstallmentSuccess] = useState(0); // ຈຳນວນເງິນທີ່ຊຳລະ (ກີບ)
  const [countInstallmentSuccess, setCountInstallmentSuccess] = useState(0); // ຈຳນວນງວດທີ່ຊຳລະ
  const [pagination, setPagination] = useState(1);
  const [totalPagination, setTotalPagination] = useState(0);
  const [backupFormData, setBackupFormData] = useState();
  const [showLoanData, setShowLoanData] = useState();
  const [hiddenEdit, setHiddenEdit] = useState(true);

  // store
  const { token, setIsLoadingDetailPage } = useStore();

  // useEffect
  useEffect(() => {
    getData();
  }, []);
  useEffect(() => {
    // ຄິດໄລ່ຍອດເງິນທີຊຳລະແລ້ວ
    if (loanData?.installmentNotes) {
      const data = loanData?.installmentNotes.filter(
        (e) => e?.installmentStatus === "SUCCESS"
      );
      if (data?.length > 0) {
        setCountInstallmentSuccess(data?.length);
        const _sum = _.sumBy(data, "principalAmount");
        setAmountInstallmentSuccess(_sum);
      }
    }
  }, [loanData]);
  useEffect(() => {
    getDataLoanHistory(loanData?._id);
  }, [loanData, pagination]);
  useEffect(() => {
    const findOneSucces = showLoanData?.installmentNotes?.find(
      (e) => e?.installmentStatus === "SUCCESS"
    );
    if (pagination !== 1) {
      setHiddenEdit(true);
    } else if (findOneSucces) {
      setHiddenEdit(true);
    } else {
      setHiddenEdit(false);
    }
  }, [pagination, showLoanData]);
  // function
  const getData = async () => {
    try {
      setIsLoading(true);
      setIsLoadingDetailPage(true);
      const data = await get_loan_by_id(loanId, "", token);
      if (data?.error) throw new Error(data?.message);
      let loan = data?.data;

      setShowLoanData(loan);
      setLoanData(loan);
      await getDataBackupFormData(loan);
      setIsLoading(false);
      setIsLoadingDetailPage(false);
    } catch (err) {
      console.error("error", err);
      setIsLoading(false);
      setIsLoadingDetailPage(false);
    }
  };
  const handlePayLoanInstallment = async (installmentId, formData) => {
    try {
      const _json = {
        ...formData,
        installmentStatus: formData?.installmentStatus,
        principalAmount: formData?.principalAmount.toString(),
      };
      const data = await update_installment(installmentId, _json, token);
      if (data?.error) {
        throw new Error(data?.message);
      }
      getData();
      setPopup();
    } catch (err) {
      console.error(err);
    }
  };
  const handleSelectInstallment = async (installment) => {
    if (pagination !== 1) return;
    if (installment?.installmentStatus === "NOT_PAYMENT_DATE") {
      setPopup({ PopUpPayLoan: true });
      setSelectLoanInstallment(installment);
      // WarningSwal("ຍັງບໍ່ຮອດມືຊຳລະເທື່ອ");
    } else if (installment?.installmentStatus === "WAITING") {
      setPopup({ PopUpPayLoan: true });
      setSelectLoanInstallment(installment);
    } else if (installment?.installmentStatus === "SUCCESS") {
      setPopup({ PopUpDetailInstallment: true });
      setSelectLoanInstallment(installment);
    } else if (installment?.installmentStatus === "ARREARS") {
      setPopup({ PopUpPayLoan: true });
      setSelectLoanInstallment(installment);
    }
  };
  const handleUpdateInstallment = async (installmentData) => {
    try {
      // DOING: ຝັງຊັ້ນອັບເດດ installment
      await update_activity_history(
        installmentData?._id,
        installmentData,
        token
      );
      setPopup();
      getData();
    } catch (err) {
      console.error("error", err);
      setIsLoading(false);
    }
  };

  const getDataBackupFormData = async (formData) => {
    try {
      if (!formData) throw new Error("getDataBackupFormData error");
      const memberData = await get_member(formData?.memberId?._id, token);
      const inputSearch = memberData?.data?.memberNo;
      setBackupFormData({
        formData: formData,
        memberData: memberData.data,
        inputSearch: inputSearch,
      });
    } catch (err) {
      console.error(err);
    }
  };
  const onClickEdit = async () => {
    setPopup({ PopUpUpdateLoan: true });
    setDropdown(false);
  };
  const handleUpdateLoan = async (formData) => {
    try {
      const data = await update_loan(formData?._id, formData, token);
      if (data.error) {
      }
      setPopup();
      getData();
    } catch (err) {
      console.error(err);
    }
  };
  const getDataLoanHistory = async (loanId) => {
    if (!loanId) return;
    let skipData = (pagination - 1) * limitData;
    const _data = await get_loan_historys(loanId, skipData, limitData, token);
    // setActivityHistoryRecordData(_data);
    setTotalPagination(Math.ceil(_data?.total / limitData) + 1);
    if (pagination ===1) {
      if (loanData) {
        setShowLoanData(loanData);
      } else {
        getData();
      }
    } else {
      let skipData = (pagination - 2) * limitData;
      const _data = await get_loan_historys(loanId, skipData, limitData, token);
      // setShowLoanData(loanData);
      if (_data?.data?.length === 0) return;
      let _loanData = JSON.parse(_data?.data?.[0]?.loandData);
      setShowLoanData(_loanData);
    }
  };

  return (
    <div>
      <Breadcrumb>
        <Breadcrumb.Item onClick={() => navigate("/loan", { replace: true })}>
          ປ່ອຍກູ້ ແລະ ເກັບຄືນ
        </Breadcrumb.Item>
        <Breadcrumb.Item active>ລາຍລະອຽດ</Breadcrumb.Item>
      </Breadcrumb>
      <Card
        style={{
          padding: 16,
          minHeight: "80dvh",
          position: "relative",
          paddingBottom: 150,
        }}
      >
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <h2 style={{ marginBottom: "20px" }}>ຂໍ້ມູນປ່ອຍກູ້</h2>
          <div
            style={{
              position: "relative",
              display: hiddenEdit ? "none" : "block",
            }}
          >
            <div
              onClick={() => setDropdown((prev) => !prev)}
              style={{
                cursor: "pointer",
              }}
            >
              <Icon icon={"uil:ellipsis-h"} style={{ width: 24, height: 24 }} />
            </div>
            <div
              style={{
                position: "absolute",
                top: "80%",
                right: "0",
                border: "1px solid rgba(0,0,0,0.1)",
                boxShadow: "1px 1px 3px 5px rgba(0,0,0,0.025)",
                borderRadius: 8,
                minWidth: 100,
                overflow: "hidden",
                display: dropdown ? "block" : "none",
                backgroundColor: "#fff",
                zIndex: 1,
              }}
            >
              <ItemMenuButton
                style={{
                  color: "#343A40",
                }}
                onClick={onClickEdit}
              >
                ແກ້ໄຂ
              </ItemMenuButton>
              {/* <ItemMenuButton
                style={{
                  color: "#FF0000",
                }}
                onClick={onClickDelete}
              >
                ລຶບ
              </ItemMenuButton> */}
            </div>
          </div>
        </div>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: 20,
            gridGap: 20,
            width: "100%",
            marginBottom: "36px",
          }}
        >
          <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
            <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
              {[
                {
                  title: "ເລກສະມາຊິກ:",
                  value: showLoanData?.memberId?.memberNo
                    ? cutBranchNo(showLoanData?.memberId?.memberNo)
                    : "-",
                },
                {
                  title: "ຊື່ ແລະ ນາມສະກຸນ:",
                  value: showLoanData?.memberId?.fullName || "-",
                },
                {
                  title: "ເພດ:",
                  value: showLoanData?.memberId?.gender
                    ? converSex(showLoanData?.memberId?.gender)
                    : "-",
                },
                {
                  title: "ເບີໂທ:",
                  value: showLoanData?.memberId?.phone || "-",
                },
                {
                  title: "ຜູ້ສ້າງລາຍການ:",
                  value: showLoanData?.createdBy?.fullName || "-",
                },
                {
                  title: "ວັນເວລາປ່ອຍກູ້:",
                  value: showLoanData?.createdAt
                    ? moment(showLoanData?.createdAt).format("DD/MM/YYYY HH:mm")
                    : "-",
                },
                {
                  title: "ປະເພດ:",
                  value: showLoanData?.loanyManagementType,
                },
                {
                  title: "ເອກະສານສັນຢາ:",
                  value: (
                    <span
                      style={{
                        color: "#0178C1",
                        cursor: "pointer",
                        textDecoration: "underline",
                      }}
                      onClick={() => setPopup({ PopUpShowImage: true })}
                    >
                      ຮູບພາບ
                    </span>
                  ),
                },
              ].map((e, i) => (
                <div className="list-data" key={i}>
                  <div>{e?.title}</div>
                  <div>{e?.value}</div>
                </div>
              ))}
            </div>
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
            <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
              {/* <h2>ຂໍ້ມູນສ່ວນໂຕ</h2> */}
              {[
                {
                  title: "ງວດຊຳລະ:",
                  value: (
                    <>
                      <span style={{ color: "#0178C1" }}>
                        {countInstallmentSuccess || "-"}
                      </span>{" "}
                      / {showLoanData?.loanTerm || "-"}
                    </>
                  ),
                },
                {
                  title: "ຈຳນວນເງິນກູ້ທັງໝັດ(ກີບ):",
                  value: (
                    <span style={{ color: "#0178C1" }}>
                      {showLoanData?.loanAmount
                        ? convertNumber(showLoanData?.loanAmount)
                        : "-"}
                    </span>
                  ),
                },
                {
                  title: "ຈຳນວນເງິນຕົ້ນທືນທັງໝົດທີ່ຊຳລະ (ກີບ) ",
                  value: amountInstallmentSuccess
                    ? convertNumber(amountInstallmentSuccess)
                    : "-",
                },
                {
                  title: `ຈໍານວນເງີນດອກເບ້ຍທັງໝົດທີຊໍາລະ ${
                    showLoanData?.interestRate
                      ? convertPercent(showLoanData?.interestRate)
                      : "-"
                  }/ເດືອນ(ກີບ):`,
                  value: showLoanData?.profitOfInterestRate
                    ? convertNumber(showLoanData?.profitOfInterestRate)
                    : "-",
                },

                {
                  title: "ໄລຍະເວລາ:",
                  value: `${showLoanData?.loanTerm || "-"} ເດືອນ`,
                },
                {
                  title: "ຈຳນວນເງິນທັງໝົດທີ່ຍັງບໍ່ຊຳລະ (ກີບ):",
                  value: showLoanData?.totalRepaymentAmount
                    ? convertNumber(showLoanData?.totalRepaymentAmount)
                    : "-",
                },
                { title: "ລາຍລະອຽດ:", value: showLoanData?.description || "-" },
              ].map((e, i) => (
                <div className="list-data" key={i}>
                  <div>{e?.title}</div>
                  <div>{e?.value}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
        <h2 style={{ marginBottom: "20px" }}>ຕາຕະລາງເກັບຄືນ</h2>
        <div className="list-data" style={{ marginBottom: "20px" }}>
          <div>ຮູບແບບການຊຳລະດອກເບ້ຍ:</div>
          <div>
            {showLoanData?.loanType
              ? convertTypeLoan(showLoanData?.loanType)
              : "-"}
          </div>
        </div>
        <div style={{ overflow: "auto" }}>
          <table style={{ width: "100%" }}>
            <thead>
              <tr>
                <th>ງວດທີ</th>
                <th style={{ textAlign: "end" }}>ຈຳນວນເງິນຕົ້ນ (ກີບ)</th>
                <th style={{ textAlign: "end" }}>ດອກເບ້ຍ (ກີບ)</th>
                <th style={{ textAlign: "end" }}>ຄ່າປັບໃໝ (ກີບ)</th>
                <th style={{ textAlign: "end" }}>ຈຳນວນເງິນທີ່ຕ້ອງຊຳລະ (ກີບ)</th>
                <th>ວັນທີ່ຕ້ອງຊຳລະເງິນ</th>
                <th>ສະຖານະ</th>
                <th>ຜູ້ດຳເນີນລາຍການ</th>
              </tr>
            </thead>
            <tbody>
              {showLoanData?.installmentNotes
                ?.sort((a, b) => {
                  return a?.installmentNoteNo - b?.installmentNoteNo;
                })
                ?.map((e, i) => (
                  <tr 
                    onClick={() => handleSelectInstallment(e)}
                    key={i}
                    style={{
                      cursor: "pointer",
                      backgroundColor:
                        e?.installmentStatus === "WAITTING"
                          ? "rgba(255, 138, 0,0.15)"
                          : "none",
                    }}
                  >
                    <td>{e?.installmentNoteNo}</td>
                    <td style={{ textAlign: "end" }}>
                      {e?.principalAmount
                        ? convertNumber(e?.principalAmount)
                        : "-"}
                    </td>
                    <td style={{ textAlign: "end" }}>
                      {e?.interestRateAmount
                        ? convertNumber(e?.interestRateAmount)
                        : "-"}
                    </td>
                    <td style={{ textAlign: "end" }}>
                      {e?.lateFeesAmount
                        ? convertNumber(e?.lateFeesAmount)
                        : "-"}
                    </td>
                    <td style={{ textAlign: "end" }}>
                      {e?.interestRateAmount && e?.principalAmount
                        ? convertNumber(
                            e?.principalAmount + e?.interestRateAmount )
                        : "-"}
                    </td>
                    <td>
                      {e?.dueDate
                        ? moment(e?.dueDate).format("DD/MM/YYYY")
                        : "-"}
                    </td>
                    <td>
                      {e?.installmentStatus
                        ? convertStatusLoan(e?.installmentStatus)
                        : "-"}
                    </td>
                    <td>
                      {e.installmentStatus === "SUCCESS" && e?.updatedBy?.fullName && (
                        e?.updatedBy?.fullName)}
                      {e.installmentStatus === "SUCCESS" && !e?.updatedBy?.fullName && ("ລູກໜີ້ຈ່າຍຜ່ານ Phapay")}
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
        <div
          style={{
            display: isLoading ? "none" : "flex",
            justifyContent: "center",
            width: "100%",
            padding: 10,
            paddingTop: 40,
          }}
        >
          {/* DOING: ເຮັດ pagination ລາຍການແກ້ໄຂ */}
          <ReactPaginate
            previousLabel={
              <span className="glyphicon glyphicon-chevron-left">{`<`}</span>
            }
            nextLabel={
              <span className="glyphicon glyphicon-chevron-right">{`>`}</span>
            }
            breakLabel={<Pagination.Item disabled>...</Pagination.Item>}
            breakClassName={"break-me"}
            pageCount={totalPagination} // Replace with the actual number of pages
            marginPagesDisplayed={1}
            pageRangeDisplayed={4}
            onPageChange={(e) => {
              setPagination(e?.selected + 1);
            }}
            containerClassName={"pagination justify-content-center"} // Bootstrap class for centering
            pageClassName={"page-item"}
            pageLinkClassName={"page-link"}
            activeClassName={"active"}
            previousClassName={"page-item"}
            nextClassName={"page-item"}
            previousLinkClassName={"page-link"}
            nextLinkClassName={"page-link"}
          />
        </div>
      </Card>
      {/* popup */}
      <PopUpPayLoan
        open={popup?.PopUpPayLoan}
        onClose={() => {
          setPopup();
          setSelectLoanInstallment();
        }}
        installmentData={selectLoanInstallment}
        onSubmit={handlePayLoanInstallment}
        memberData={loanData?.memberId}
        loanData={loanData}
      />
      <PopUpUpdatePayLoan
        open={popup?.PopUpUpdatePayLoan}
        onClose={() => {
          setPopup();
          setSelectLoanInstallment();
        }}
        installmentData={selectLoanInstallment}
        onSubmit={handlePayLoanInstallment}
        memberData={loanData?.memberId}
      />
      <PopUpShowImage
        open={popup?.PopUpShowImage}
        image={END_IMAGE + loanData?.contractImage}
        onClose={() => setPopup()}
      />
      <PopUpDetailInstallment
        open={popup?.PopUpDetailInstallment}
        installmentData={selectLoanInstallment}
        memberData={loanData?.memberId}
        onClose={() => setPopup({ PopUpDetailInstallment: false })}
        onClickDelete={() => setPopup({ PopUpConfirmDelete: true })}
        onClickEdit={() => {
          setPopup({ PopUpUpdateDepositAndWithdraw: true });
        }}
      />
      <PopUpUpdateLoan
        open={popup?.PopUpUpdateLoan}
        backupFormData={backupFormData}
        setBackupFormData={setBackupFormData}
        setPopup={setPopup}
        onClose={() => setPopup()}
        onSubmit={handleUpdateLoan}
      />
      <PopUpConfirmDiscretion //for updata activity history
        open={popup?.PopUpConfirmDiscretion_for_update}
        onClose={() => {
          setPopup({ PopUpUpdateDepositAndWithdraw: true });
        }}
        onSubmit={() => {
          setBackupFormData((prev) => ({
            ...prev,
            formData: { ...prev?.formData, manualCheck: true },
          }));
          setPopup({ PopUpUpdateLoan: true });
        }}
      />
    </div>
  );
}

const ItemMenuButton = styled("div")({
  padding: 10,
  color: "#FF0000",
  cursor: "pointer",
  width: "100%",
  zIndex: 1,
  position: "relative",
  "&:hover": {
    backgroundColor: "rgba(0,0,0,0.05)",
  },
});
